/**
 * Created by sugimoto on 2016/12/19.
 */
if (!global || !global._babelPolyfill) {
  console.log('Loading babelPolyfill from Clip');
  require('babel-polyfill');
}

import React  from 'react';
import ReactDOM from 'react-dom';
import Clip from './clip.jsx';
import {SearchWebUtils} from '@aperza/react-ui';

import {IntlProvider, addLocaleData } from 'react-intl';

import ja from 'react-intl/locale-data/ja';
addLocaleData([...ja]);

let messages = {
  en: require('./i18n/en.json'),
  ja: require('./i18n/ja.json'),
} ;

let locale = SearchWebUtils.getLocale();

let element = document.getElementById('clip-component');
if( element != null){
    ReactDOM.render(
      <IntlProvider locale={locale} messages={messages[locale]}>
        <Clip
            menuType = {element.getAttribute("data-menu-type")}
            serviceId={element.getAttribute("data-service-id")}
            contentsType={element.getAttribute("data-contents-type")}
            contentsDetailType={element.getAttribute("data-contents-detail-type")}
            clipUrl={element.getAttribute("data-clip-url")}
            clipTitle={element.getAttribute("data-clip-title")}
            clipImageUrl={element.getAttribute("data-clip-image-url")}/>
      </IntlProvider>,
        element);
}

let elements = document.getElementsByClassName('clip-component');
if( elements != null ){
    let elementsArray = Array.from(elements);
    elementsArray.forEach(function(element){
        ReactDOM.render(
          <IntlProvider locale={locale} messages={messages[locale]}>
            <Clip
                menuType = {element.getAttribute("data-menu-type")}
                serviceId={element.getAttribute("data-service-id")}
                contentsType={element.getAttribute("data-contents-type")}
                contentsDetailType={element.getAttribute("data-contents-detail-type")}
                clipUrl={element.getAttribute("data-clip-url")}
                clipTitle={element.getAttribute("data-clip-title")}
                clipImageUrl={element.getAttribute("data-clip-image-url")}/>
          </IntlProvider>,
            element);
    });
}



// WEBPACK FOOTER //
// ./indexClip.js